import { enumeration } from '@dazn/peng-html5-tools-utils';
/**
 * A string enum of all available public event types.
 *
 * NB: Values are in lowercase with no delineation as per DOM event name convention.
 */
var EventType = enumeration({
    ACTIVE_AUDIO_TRACK_CHANGE: 'activeaudiotrackchange',
    ACTIVE_TEXT_TRACK_CHANGE: 'activetexttrackchange',
    AD_BREAK_END: 'adbreakend',
    AD_BREAK_START: 'adbreakstart',
    AD_END: 'adend',
    AD_START: 'adstart',
    ADAPTATION: 'adaptation',
    ADAPTIVE_PRESENTATION_DELAY_DISABLED: 'adaptivepresentationdelaydisabled',
    ADAPTIVE_PRESENTATION_DELAY_ENABLED: 'adaptivepresentationdelayenabled',
    ADAPTIVE_PRESENTATION_DELAY_TERMINATED: 'adaptivepresentationdelayterminated',
    ASSET_METADATA_CHANGE: 'assetmetadatachange',
    AUDIO_TRACKS_CHANGE: 'audiotrackschange',
    BANDWIDTH_ESTIMATE_CHANGE: 'bandwidthestimatechange',
    BUFFER_DURATION_CHANGE: 'bufferdurationchange',
    BUFFER: 'buffer',
    COMSCORE_AD_METADATA: 'comscoreadmetadata',
    COMSCORE_CONTENT_METADATA: 'comscorecontentmetadata',
    COMSCORE_NOTIFY_END: 'comscorenotifyend',
    COMSCORE_NOTIFY_PAUSE: 'comscorenotifypause',
    COMSCORE_NOTIFY_PLAY: 'comscorenotifyplay',
    COMSCORE_POSITION_UPDATE: 'comscorepositionupdate',
    COMSCORE_SESSION_START: 'comscoresessionstart',
    CONNECTION_LOSS: 'connectionloss',
    CSIWM_ENABLED: 'csiwmenabled',
    CSVWM_ENABLED: 'csvwmenabled',
    CUE_CHANGE: 'cuechange',
    DAZN_ERROR: 'daznerror',
    DEBUG_MESSAGE: 'debugmessage',
    DESTROYED: 'destroyed',
    DRM_KEY_SESSION_STATE_CHANGE: 'drmkeysessionstatechange',
    ENDED: 'ended',
    ERROR: 'error',
    FETCHING: 'fetching',
    GOOGLE_AD: 'googlead',
    HTTP_REQUEST_STATE_CHANGE: 'httprequeststatechange',
    LOADED: 'loaded',
    LOADING: 'loading',
    MEDIA_TYPE_CHANGE: 'mediatypechange',
    MESSAGE: 'message',
    MULTICAST_STATUS_CHANGE: 'multicaststatuschange',
    NIELSEN_END: 'nielsenend',
    NIELSEN_LOAD_METADATA: 'nielsenloadmetadata',
    NIELSEN_SET_PLAYHEAD_POSITION: 'nielsensetplayheadposition',
    NIELSEN_STOP: 'nielsenstop',
    NIELSEN_UPDATE_METADATA: 'nielsenupdatemetadata',
    PACKAGE_REGISTERED: 'packageregistered',
    PAUSE: 'pause',
    PERIOD_CHANGE: 'periodchange',
    PERSONALISATION_METADATA_CHANGE: 'personalisationmetadatachange',
    PLAY: 'play',
    PLAYBACK_RATE_CHANGE: 'playbackratechange',
    PRESENTATION_DELAY_ACHIEVED: 'presentationdelayachieved',
    PRESENTATION_DELAY_PENDING: 'presentationdelaypending',
    QUALITY_CHANGE_RECENT: 'qualitychangerecent',
    QUALITY_CHANGE_SESSION: 'qualitychangesession',
    REBUFFER: 'rebuffer',
    RESET: 'reset',
    SEEK_END: 'seekend',
    SEEK_START: 'seekstart',
    SESSION_ID_CHANGE: 'sessionidchange',
    SOLUTION_EVENT: 'solutionevent',
    SUPPORTED_CODECS_IDENTIFIED: 'supportedcodecsidentified',
    TARGET_METADATA_PARSED: 'targetmetadataparsed',
    TARGET_PROFILE_SELECTED: 'targetprofileselected',
    TEXT_TRACKS_CHANGE: 'texttrackschange',
    THEATRE_MODE_AVAILABLE_CHANGE: 'theatremodeavailablechange',
    TIME_REMAINING: 'timeremaining',
    TIME_UPDATE: 'timeupdate',
    UI_METADATA_CHANGE: 'uimetadatachange',
    UNLOADED: 'unloaded',
    VOLUME_CHANGE: 'volumechange',
});
export { EventType };
//# sourceMappingURL=EventType.js.map